import StyledContainer from "style/styledContainer"
import styled, { css } from "styled-components"

import { ScrollOutBoxWrap, DrawerWinOneTileWrap, DrawerWinTwoTileWrap, ListBottomGradientWrap, ListTopGradientWrap, PaddingLeftRightWrap, ScrollBoxWrap } from "../Drawer/DrawerStyle"
import { useCallback, useEffect, useState } from "react"
import { Column, Row } from "style/preset"
import DrawerCom from "components/Drawer/DrawerCom"
import { supportWallet, supportWalletByBRC20 } from "utils/walletManage"
import { WalletInfo } from "types/baseType"
import { useAccount } from "wagmi"

import useWalletConnect from "hooks/useWalletConnect"
import { useAppSelector } from "hooks/redux/hooks"
import CImage from "components/CImage"
import useWalletConnectNoEvm from "hooks/useWalletConnectNoEvm"
import { getCurConnectWalletFlag } from "utils/store"

interface Props {
    open: boolean
    closeChange?: (isOpen: boolean) => void
    onComplete?: (obj?: any) => void
}

const DrawerWalletCom = ({open, closeChange = (isOpen) => {}, onComplete = (obj) => {}}: Props) => {
    const { brc20 } = useAppSelector((state) => state.app)
    const { isConnected } = useAppSelector((state) => state.wallet)
    const { fromChain } = useAppSelector((state) => state.coreInfo)

    /**
     * 资源初始化
     */
    const fnInit = useCallback(() => {
        if(open) {
            // 初始化资源

        } else {
            // 清理资源

        }
    }, [open])

    useEffect(() => {
        fnInit()
    }, [fnInit])

    /**
     * 关闭回调
     */
    const [closeRandom, setCloseRandom] = useState(0)
    const fnClosed = (closed: boolean) => {
        closeChange(closed)
        setCloseRandom(0)
    }

    /**
     * 连接钱包
     */
    const { connector } = useAccount()
    const { connectWallet } = useWalletConnect()

    useEffect(() => {
        if(isConnected) {
            setCloseRandom(1)
        }
    }, [isConnected])

    /**
     * 连接非EVM钱包，BRC20钱包
     */
    const { connectWallet: connectWalletNoEvm } = useWalletConnectNoEvm()

    return open ? <DrawerCom isOpen={open} closeRandom={closeRandom} onClose={fnClosed}>
        <DrawerContentWrap>
            <PaddingLeftRightWrap>
                <DrawerWinOneTileWrap>Connect a wallet</DrawerWinOneTileWrap>
                <DrawerWinTwoTileWrap $mb="30px">Choose from our growing selection of supported wallets</DrawerWinTwoTileWrap>
            </PaddingLeftRightWrap>
            
            <ScrollOutBoxWrap $height="calc(100% - 100px) !important;">
                <ListTopGradientWrap></ListTopGradientWrap>
                <ListBottomGradientWrap></ListBottomGradientWrap>
                <ScrollBoxWrap>
                    <StyledContainer $height="30px"></StyledContainer>
                    {
                        brc20 && fromChain?.nickName === 'BTC' ? supportWalletByBRC20.map((item : WalletInfo, index) => <WalletItemCom walletInfo={item} onClick={() => connectWalletNoEvm(item)} isActive={isConnected && item.flag === getCurConnectWalletFlag()} key={index}></WalletItemCom>) : 
                        supportWallet.map((item : WalletInfo, index) => <WalletItemCom walletInfo={item} onClick={() => connectWallet(item)} isActive={isConnected && item.name === connector?.name} key={index}></WalletItemCom>)
                    }
                    <StyledContainer $height="30px"></StyledContainer>
                </ScrollBoxWrap>
            </ScrollOutBoxWrap>
        </DrawerContentWrap>
    </DrawerCom> : <></>
}

interface WalletItemProps {
    walletInfo: WalletInfo
    isActive: boolean
    onClick: () => void
} 
const WalletItemCom = ({walletInfo, isActive, onClick}: WalletItemProps) => {
    return <WalletCardWrap $active={isActive} onClick={onClick}>
        <Row $pointer $justifyContent="space-between" $flex1="1" $mr="8px">
            <Row>
                <CImage width="26px" height="26px" src={walletInfo.icon}></CImage>
                <Column $ml="10px">
                    <StyledContainer $fontSize="16px" $lineHeight="18px" $fontWeight5>{walletInfo.name}</StyledContainer>
                </Column>
            </Row>
            <ConnectFlagWrap>Connect</ConnectFlagWrap>
        </Row>
    </WalletCardWrap>
}

const DrawerContentWrap = styled(StyledContainer)`
    height: 100%;
`

const WalletCardWrap = styled(Row)<{$active: boolean}>`
    padding: 17px 20px;
    justify-content: space-between;
    box-shadow: 0px 2px 2px -2px rgba(24, 39, 75, 0.06), 0px 1px 2px 0px rgba(24, 39, 75, 0.08);
    border-radius: 9px;
    background-color: ${({theme}) => theme.basicWhite};
    margin-bottom: 10px;
    &:hover {
        box-shadow: 0px 8px 24px -4px rgba(24, 39, 75, 0.08), 0px 6px 12px -6px rgba(24, 39, 75, 0.12);
    };

    ${
        ({$active, theme}) => $active ? css`
            ${ConnectFlagWrap} {
                background-color: ${theme.basicPurple};
                color: ${theme.basicWhite};
            }
        ` : css`
        `
    }
`

const ConnectFlagWrap = styled(StyledContainer)`
    font-size: 12px;
    font-weight: 600;
    line-height: 14px;

    padding: 9px 8px;
    border-radius: 12px;

    color: #767A7F;
    background-color: #F6F5F4;
`

export default DrawerWalletCom